<!-- 商品详情 -->
<template>
  <div class="poasterPopBg">
    <div class="flexRow commentContainerPop postImageContainer">
      <div class="cursor closeIconWhite" @click="$emit('closeshare')"></div>
      <div id="catImg" class="innerContainer">
        <div class="flexColumn posterContent">
          <div
            class="imgContainer"
            :style="{
              height: $attrs.height ? `${$attrs.height}px !important` : '',
            }"
          >
            <img
              :src="`${
                $attrs.book.BookPosterUrl || $attrs.book.subImg || $attrs.book.CoverUrl
              }?v=${Math.ceil(Math.random() * 100000)}`"
              crossorigin="anonymous"
              :key="`${$attrs.book.BookPosterUrl || $attrs.book.subImg || $attrs.book.CoverUrl}`"
              style="width: 100%; height: 100%; border: 0px solid #f00"
              alt
            />
          </div>
          <p class="title">{{ $attrs.book.Title }}</p>
          <div class="flexRow" v-if="$attrs.book.Author || $attrs.book.bookEditorInChief">
            <p class="author" v-if="$attrs.book.bookEditorInChief">
              <span class="editorInChief">{{ $attrs.book.bookEditorInChief }}</span>
            </p>
            <p class="author" v-else-if="$attrs.book.Author">
              <span class="authorName">{{ $attrs.book.Author }}</span>
            </p>
          </div>
        </div>
        <div class="flexColumn pt24" style="background: #fff; border-radius: 0 0 5px 5px">
          <div class="shareBottomContainer pb24">
            <img :src="shareBottomBg" class="shareBottomContainerImg" alt />
            <div class="qrCode" v-if="$attrs.shareUrl">
              <VueQr :size="70" margin="0" :text="$attrs.shareUrl"></VueQr>
            </div>
          </div>
        </div>
      </div>
      <div class="cursor flexRow bottomCloseContainer" @click="download">
        <div class="xiazaiIcon"></div>
        <div class="downloadText">下载保存</div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue"
import VueQr from "vue-qr"
import { Toast } from "vant"
import html2canvas from "html2canvas"

import defaultLogo from "@/assets/base/shareBottomBg@2x.png"
import testLogo from "@/assets/images/logo/test/shareLogo.png"
import yanjiuyuanLogo from "@/assets/images/logo/yanjiuyuan/shareLogo.png"

const logoConfig = {
  default: defaultLogo,
  test: testLogo,
  yanjiuyuan: yanjiuyuanLogo,
}

Vue.use(Toast)

export default {
  components: {
    VueQr,
  },
  data() {
    return {
      shareBottomBg:
        window.__appBaseConfig__.WEB_APP_SHARE_LOGO_PATH ||
        logoConfig[window.__appBaseConfig__.WEB_APP_SHARE_LOGO_PATH] ||
        logoConfig["default"],
    }
  },
  created() {},
  methods: {
    download() {
      const opts = {
        scale: 3,
        useCORS: true, // 【重要】开启跨域配置
        allowTaint: true,
        logging: true,
        backgroundColor: null,
      }
      const copyEle = document.getElementById("catImg") || document.createElement("div")

      html2canvas(copyEle, opts).then(canvas => {
        const url = canvas.toDataURL()
        // 以下代码为下载此图片功能
        const a = document.createElement("a")
        a.setAttribute("href", url)
        a.setAttribute("download", `${this.$attrs.book.Title}.png`)
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      })
      this.$emit("closeshare")
    },
  },
}
</script>

<style lang="less" scoped>
.commentContainerPop {
  // zoom: 0.75;
  // width: 590px;
  background: #fff;
  border-radius: 10px;
  padding: 63px 0 53px 0px;
  align-items: flex-start;
  position: relative;
  .titleContainer {
    margin-bottom: 41px;
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    text-align: center;
  }
  .tipMessage {
    width: 475px;
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 51px;
  }
  .commentStarContainer {
    width: 522px;
    border: 0px solid #e5e5e5;
    padding: 20px;
    position: relative;
  }
  .commentInputContainer {
    width: 522px;
    height: 301px;
    border: 1px solid #e5e5e5;
    padding: 20px;
    position: relative;
    textarea {
      height: 100%;
      width: 100%;
      resize: none;
      border: none;
    }
    .inputLength {
      position: absolute;
      bottom: 20px;
      right: 20px;
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #999999;
    }
  }
  .buttonContainer {
    padding-top: 40px;
    .continueBtn {
      width: 207px;
      height: 73px;
      background: #dedede !important;
      border-radius: 36px;
    }
    .saveBtn {
      width: 181px;
      height: 73px;
      background: #088190;
      border-radius: 36px;

      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
  }
  .bottomCloseContainer {
    position: absolute;
    bottom: -40px;
    .downloadText {
      margin-left: 10px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
    }
    .xiazaiIcon {
      width: 25px;
      height: 25px;
    }
  }
}
.sharePopContainer {
  width: 749px;
  background: #ffffff;
  border-radius: 10px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding-top: 60px;
  .cancelShare {
    height: 104px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
  .bottomLine {
    margin: 59px 0 0 0;
    border-bottom: 1px solid #e7e7e7;
  }
  .sharesItem {
    text-align: center;
    .shareIconImg {
      width: 91px;
      margin-bottom: 30px;
      img {
        width: 100%;
      }
    }
    .shareName {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #666666;
    }
  }
}
.postImageContainer {
  padding: 0 !important;
  flex-grow: 0;
  flex-shrink: 0;
  background: rgb(255, 255, 255);
  padding: 0px;
  width: 300px;
  border-radius: 115px;
  .innerContainer {
    background: #f7f0e3;
    width: 100%;
    border-radius: 5px;
    .posterContent {
      justify-content: center;
      align-items: center;
      .title {
        font-size: 16px;
        color: #333333;
        font-weight: 500;
        text-align: center;
        margin-bottom: 10px;
      }
      .author {
        font-size: 14px;
        color: #666;
        text-align: center;
        margin-bottom: 20px;
      }
    }
    .imgContainer {
      width: 100%;
      height: 290px !important;
      border-radius: 5px !important;
      position: relative;
      padding: 22px 28px 20px;
      img {
        object-fit: contain;
      }
    }
    .dashLine {
      margin: 0 28px 17px;
      border-bottom: 1px dashed #dcdcdc;
    }
    .shareBottomContainer {
      position: relative;
      display: flex;
      justify-content: space-around;
      align-items: center;
      border-radius: 0 0 5px 5px;
      .qrCode {
        width: 70px;
        height: 70px;
        // top: 11px;
        // left: 21px;
        // position: absolute;
      }
    }
  }

  .closeIconWhite {
    position: absolute;
    top: -30px;
    right: -30px;
    width: 30px;
    height: 30px;
  }
}

.shareBottomContainerImg {
  width: 180px;
  // height: 93px;
  // object-fit: contain;
}
</style>
